var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgTables(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87957 5.9219H15.7096C15.9331 5.9219 16.1131 5.7389 16.1131 5.5154C16.1131 5.2889 15.9331 5.1074 15.7096 5.1074H7.87957C7.65757 5.1074 7.47607 5.2889 7.47607 5.5154C7.47607 5.7389 7.65757 5.9219 7.87957 5.9219Z",
    fill: "#506C8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7101 17.4669H7.88006C7.65656 17.4669 7.47656 17.6499 7.47656 17.8749C7.47656 18.0999 7.65656 18.2829 7.88006 18.2829H15.7101C15.9321 18.2829 16.1136 18.0999 16.1136 17.8749C16.1136 17.6499 15.9321 17.4669 15.7101 17.4669Z",
    fill: "#506C8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87957 12.3005H12.7096C12.9331 12.3005 13.1131 12.1175 13.1131 11.8925C13.1131 11.6675 12.9331 11.4845 12.7096 11.4845H7.87957C7.65757 11.4845 7.47607 11.6675 7.47607 11.8925C7.47607 12.1175 7.65757 12.3005 7.87957 12.3005Z",
    fill: "#506C8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 20.6309H18.951V15.1619H5.625V20.6309ZM5.625 14.0369H18.951V9.17238H5.625V14.0369ZM5.625 8.04738H18.951V2.62488H5.625V8.04738ZM19.5135 1.49988H5.0625C4.752 1.49988 4.5 1.75188 4.5 2.06238V21.1934C4.5 21.5039 4.752 21.7559 5.0625 21.7559H19.5135C19.824 21.7559 20.076 21.5039 20.076 21.1934V2.06238C20.076 1.75188 19.824 1.49988 19.5135 1.49988Z",
    fill: "#506C8E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTables);
export default __webpack_public_path__ + "static/media/Tables.3b93b5b7ebe8a05dd18edfb95890083f.svg";
export { ForwardRef as ReactComponent };